import React, { useEffect, useState } from 'react'
import {
    H5,
    Table,
    FormikInput,
    Divider,
    Row,
    Col,
    FormikTextArea,
    FormikSimpleSelect,
    Card,
    FormikCheckbox,
    FormInput,
    FormikDate
} from '../../../Elements'

import { useMediaQuery } from 'react-responsive'
import { ColorAdditionsRow, CrewInformationRow } from './SharedPebbleForms'
import { GeneralComments } from './JobDetailForm'
import moment from 'moment'

const thirdWidthStyle = {
    maxWidth: '20%',
    display: 'inline-block',
    margin: '5%'
}

const cardStyle = {
    minWidth: 300
}

const dividerStyle = {
    marginBottom: '20px'
}

export const PebbleDimensionsForm = ({ valuePrefix, values }) => {

    const customOnChangeCalc = (rawThisName, thisNewVal, { is_mmg }) => {
        const targetThisName = rawThisName.split('.')[2]
        let valueSet = {
            depth_low: values.depth_low,
            depth_mid: values.depth_mid,
            depth_high: values.depth_high,
            mmg_ia: values.mmg_ia,
            quoted_ia: values.quoted_ia,
            mmg_pebble_perimeter: values.mmg_pebble_perimeter,
            plan_ia: values.plan_ia,
            plan_sa: values.plan_sa,
            pebble_perimeter: values.pebble_perimeter
        }
        valueSet[targetThisName] = thisNewVal

        //determine how many depth values have been entered
        const parsedDepthLow = !isNaN(parseFloat(valueSet.depth_low))
            ? parseFloat(valueSet.depth_low)
            : 0
        const parsedDepthMid = !isNaN(parseFloat(valueSet.depth_mid))
            ? parseFloat(valueSet.depth_mid)
            : 0
        const parsedDepthHigh = !isNaN(parseFloat(valueSet.depth_high))
            ? parseFloat(valueSet.depth_high)
            : 0

        let numberOfDepthValuesEntered = 0
        if (!isNaN(parseFloat(valueSet.depth_low))) numberOfDepthValuesEntered++
        if (!isNaN(parseFloat(valueSet.depth_mid))) numberOfDepthValuesEntered++
        if (!isNaN(parseFloat(valueSet.depth_high))) numberOfDepthValuesEntered++

        const canCalculateIA = is_mmg
            ? (numberOfDepthValuesEntered > 0 && valueSet.quoted_ia && !isNaN(parseFloat(valueSet.quoted_ia)) &&
                valueSet.mmg_pebble_perimeter && !isNaN(parseFloat(valueSet.mmg_pebble_perimeter)))
            : (numberOfDepthValuesEntered > 0 && valueSet.plan_sa && !isNaN(parseFloat(valueSet.plan_sa)) &&
                valueSet.pebble_perimeter && !isNaN(parseFloat(valueSet.pebble_perimeter)))

        const avgDepth = (parsedDepthLow + parsedDepthMid + parsedDepthHigh) / numberOfDepthValuesEntered

        const calculateIA = (is_mmg) => is_mmg
            ? parseFloat(valueSet.quoted_ia) + parseFloat(valueSet.mmg_pebble_perimeter) * avgDepth
            : parseFloat(valueSet.plan_sa) + parseFloat(valueSet.pebble_perimeter) * avgDepth

        return canCalculateIA
            ? Math.ceil(calculateIA(is_mmg))
            : is_mmg
                ? valueSet.mmg_ia
                : valueSet.plan_ia
    }

    return (
        <>
            <H5>Dimensions</H5>
            <Table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <td/>
                        <td><strong>Builder (Plan)</strong></td>
                        <td><strong>MMG</strong></td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Gunite Perimeter</strong></td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.plan_perimeter`}
                                placeholder="XXX..."
                            />
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.mmg_perimeter`}
                                placeholder="XXX..."
                            />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Pebble Perimeter</strong>
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.pebble_perimeter`}
                                placeholder="XXX..."
                                listenerComponents={[
                                    { componentName: `${valuePrefix}.plan_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: false } }
                                ]}
                            />
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.mmg_pebble_perimeter`}
                                placeholder="XXX..."
                                listenerComponents={[
                                    { componentName: `${valuePrefix}.mmg_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: true } }
                                ]}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>SA</strong></td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.plan_sa`}
                                placeholder="XXX..."
                                listenerComponents={[
                                    { componentName: `${valuePrefix}.plan_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: false } }
                                ]}
                            />
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.quoted_ia`}
                                placeholder="XXX..."
                                listenerComponents={[
                                    { componentName: `${valuePrefix}.mmg_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: true } }
                                ]}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td><strong>IA</strong></td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.plan_ia`}
                                placeholder="XXX..."
                                key={values.plan_ia}
                            />
                        </td>
                        <td>
                            <FormikInput
                                name={`${valuePrefix}.mmg_ia`}
                                placeholder="XXX..."
                                key={values.mmg_ia}
                            />
                        </td>
                    </tr>
                </tbody>
            </Table>

            <Divider />

            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_low`}
                label="Depth Low"
                placeholder="XXX..."
                listenerComponents={[
                    { componentName: `${valuePrefix}.mmg_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: true } },
                    { componentName: `${valuePrefix}.plan_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: false } }
                ]}
            />
            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_mid`}
                label="Depth Mid"
                placeholder="XXX..."
                listenerComponents={[
                    { componentName: `${valuePrefix}.mmg_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: true } },
                    { componentName: `${valuePrefix}.plan_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: false } },
                ]}
            />
            <FormikInput
                groupStyles={thirdWidthStyle}
                name={`${valuePrefix}.depth_high`}
                label="Depth High"
                placeholder="XXX..."
                listenerComponents={[
                    { componentName: `${valuePrefix}.mmg_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: true } },
                    { componentName: `${valuePrefix}.plan_ia`, componentNewValueCalculator: (a, b, c) => customOnChangeCalc(a, b, c), supportingProps: { is_mmg: false } }
                ]}
            />
        </>
    )
}

export const PebbleScheduleForm = ({ valuePrefix, filterJobStatuses, values, setFieldValue }) => {
    const [dateState, setDateState] = useState({ //DateState
        prepDate: values?.pebble_details?.prep_date,
        scheduledAppDate: values?.pebble_details?.scheduled_app_date,
        detailDate: values?.pebble_details?.detail_date
    })

    useEffect(() => {
        if (values?.pebble_details?.prep_date !== dateState.prepDate) setFieldValue(`${valuePrefix}.pebble_details.prep_date`, dateState.prepDate)
        if (values?.pebble_details?.scheduled_app_date !== dateState.scheduledAppDate) setFieldValue(`${valuePrefix}.pebble_details.scheduled_app_date`, dateState.scheduledAppDate)
        if (values?.pebble_details?.detail_date !== dateState.detailDate) setFieldValue(`${valuePrefix}.pebble_details.detail_date`, dateState.detailDate)
    }, [dateState.prepDate, dateState.scheduledAppDate, dateState.detailDate, setFieldValue, valuePrefix, values.pebble_details.prep_date, values.pebble_details.scheduled_app_date, values.pebble_details.detail_date])

    let temp_prep_date, temp_scheduled_app_date, temp_detail_date
    const crew_info = values.pebble_details.crew_information
    crew_info.forEach(crew => {
        let phase_type = crew.phase_type && crew.phase_type.name
        if (phase_type === 'Prep') {
            temp_prep_date = temp_prep_date > crew.date ? temp_prep_date : crew.date
        }

        if (phase_type === 'App') {
            temp_scheduled_app_date = temp_scheduled_app_date < crew.date ? temp_scheduled_app_date : crew.date
        }

        if (phase_type === 'Detail') {
            temp_detail_date = temp_detail_date > crew.date ? temp_detail_date : crew.date
        }
    })

    if (dateState.prepDate !== temp_prep_date ||
        dateState.scheduledAppDate !== temp_scheduled_app_date ||
        dateState.detailDate !== temp_detail_date) {
        setDateState({
            prepDate: temp_prep_date,
            scheduledAppDate: temp_scheduled_app_date,
            detailDate: temp_detail_date
        })
    }

    return (
        <>
            <H5>Schedule</H5>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.pebble_details.request_date`}
                        label='Date of Request'
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormikDate
                        name={`${valuePrefix}.pebble_details.requested_app_date`}
                        label="Requested Application Date"
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormInput
                        className='job-readonly-input'
                        disabled
                        value={values.pebble_details.prep_date}
                        type='date'
                        label='Prep Date'
                    />
                </Col>
            </Row>

            <Row>
                <Col lg={12}>
                    <FormInput
                        className='job-readonly-input'
                        disabled
                        value={values.pebble_details.scheduled_app_date}
                        type='date'
                        label='Scheduled Application Date'
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormInput
                        className='job-readonly-input'
                        disabled
                        value={values.pebble_details.detail_date}
                        type='date'
                        label='Detail Date'
                    />
                </Col>
            </Row>
            <Divider />
            <Row>
                <Col lg={12}>
                    <FormikSimpleSelect
                        name={`${valuePrefix}.status`}
                        label='Job Status'
                        items={filterJobStatuses()}
                        nullable
                        listenerComponents={[
                            {
                                componentName: `${valuePrefix}.pebble_details.app_date`, componentNewValueCalculator: (a, b, c) => {
                                    if (b && b.id && b.id === 1 && (values.pebble_details.app_date == null || values.pebble_details.app_date === "")) {
                                        return values.pebble_details.scheduled_app_date
                                    } else {
                                        return values.pebble_details.app_date
                                    }
                                }, supportingProps: {}
                            },
                            {
                                componentName: `${valuePrefix}.pebble_details.crew_information.status`,
                                componentNewValueCalculator: (a, b, c) => {
                                    if (b?.id === 19) {//Awaiting Builder 
                                        //Filter out completed, applied, canceled, on hold and weeping crew info records and keep only those with dates. 
                                        //We will clear these out and reset the status to pending
                                        c.allCrewEntries.filter(c => [1, 2, 3].includes(c.phase_type?.id)
                                            && (![1, 3, 4, 5, 6].includes(c?.status?.id) || !c?.status) && c?.date).forEach(
                                                ci => {
                                                    return (ci.date = null,
                                                        ci.status = filterJobStatuses().find(s=>s.id===2),
                                                        ci.crew = null,
                                                        ci.foreman = null)
                                                }
                                            )
                                    }
                                },
                                supportingProps: {
                                    allCrewEntries: values.pebble_details.crew_information
                                }
                            },
                            {
                                componentName: `${valuePrefix}.awaiting_builder_date`,
                                componentNewValueCalculator: (a, b, c) => {
                                   return b?.id !== 19 ?
                                    c.awaiting_builder_date = null 
                                        : c.awaiting_builder_date = moment().format('YYYY-MM-DD')
                                },
                                supportingProps: {
                                    awaiting_builder_date: values.awaiting_builder_date
                                }
                            }
                        ]}
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={6}>
                    <FormikDate
                        name={`${valuePrefix}.pebble_details.app_date`}
                        label='Application Date'
                    />
                </Col>
                {values.status?.id === 19 &&
                    <Col lg={6}>
                        <FormikDate
                            name={`${valuePrefix}.awaiting_builder_date`}
                            label='Awaiting Builder Date'
                            groupStyles={{ float: 'right' }}
                        />
                    </Col>
                }
            </Row>
        </>
    )
}

export const PebbleWorkDetailsForm = ({
                                          values,
                                          valuePrefix,
                                          pebbleColorAdditives,
                                          pebbleColors,
                                          pebbleColorMaterialTypes,
                                          poolSections,
                                          crews,
                                          employees,
                                          pebblePhases,
                                          setFieldValue,
                                          jobStatuses,
                                          jobOrders,
                                          slurryPickupOptions,
                                      }) => {
    const isMobile = useMediaQuery({query: '(max-width: 800px)'})
    return (
        <>
            <H5>Pebble Work Details</H5>
            <Row>
                <Col lg={2}>
                    <FormikCheckbox
                        name={`${valuePrefix}.pebble_details.is_complete_chip_out`}
                        label='Complete Chip Out'
                        checked={values?.pebble_details?.is_complete_chip_out}
                    />
                    <FormikCheckbox
                        name={`${valuePrefix}.pebble_details.is_update_channel_drain`}
                        label='Update Channel Drain'
                        checked={values?.pebble_details?.is_update_channel_drain}
                    />
                    <FormikCheckbox
                        name={`${valuePrefix}.pebble_details.is_trim_tile`}
                        label='Trim Tile'
                        checked={values?.pebble_details?.is_trim_tile}
                    />
                </Col>
                <Col lg={10}>
                    <FormikTextArea
                        name={`${valuePrefix}.pebble_details.notes`}
                        label="Detail Notes"
                    />
                </Col>
            </Row>
            <Divider style={dividerStyle} />
            <ColorAdditionsRow
                values={values}
                valuePrefix={valuePrefix}
                isMobile={isMobile}
                pebbleColorMaterialTypes={pebbleColorMaterialTypes}
                pebbleColors={pebbleColors}
                pebbleColorAdditives={pebbleColorAdditives}
                poolSections={poolSections}
                setFieldValue={setFieldValue}
            />
            <Divider style={dividerStyle} />
            <CrewInformationRow
                values={values}
                valuePrefix={valuePrefix}
                isMobile={isMobile}
                employees={employees}
                jobStatuses={jobStatuses}
                pebblePhases={pebblePhases}
                slurryPickupOptions={slurryPickupOptions}
                jobOrders={jobOrders}
                crews={crews}
            />
        </>
    )
}

export const PebbleNotesForm = ({ values, valuePrefix }) => {
    return (
        <Card style={cardStyle}>
            <Row>
                <Col lg={8}>
                    <GeneralComments
                        name={`${valuePrefix}.general_comments`}
                        generalComments={values?.general_comments}
                        jobDetailId={values.id}
                    />
                </Col>
                <Divider />
                <Col lg={3.9}>
                    <H5>Tile Information</H5>
                    <FormikTextArea
                        name={`${valuePrefix}.pebble_details.tile_information`}
                        rows={8}
                        maxlength="200"
                    />
                </Col>
            </Row>
        </Card>
    )
}
